angular.module('impactx.list').directive('ixSSListFilter', ['TranslationService', '$filter', '$mdDateLocale',
    function (TranslationService, $filter, $mdDateLocale) {
    return {
        scope: {
            filter: "=",
            type: "=",
            ctrl: "=",
            filterBlockIndex: "=",
            filterIndex: "=",
            dialogData: "="
        },
        restrict: 'E',
        templateUrl: 'shared/list/templates/serverside/filter.html',
        link: function (scope) {

            var boolValue,
                value,
                result = 'shared/list/templates/serverside/nofilter.tmpl.html';

            switch (scope.type) {
                case 0:
                    result = 'shared/list/templates/serverside/stringfilter.tmpl.html';
                    break;
                case 1:
                    boolValue = scope.filter.stringValue;
                    if (boolValue && boolValue !== 'false') {
                        scope.filter.stringValue = Boolean(boolValue);
                    } else {
                        scope.filter.stringValue = null;
                    }
                    result = 'shared/list/templates/serverside/booleanfilter.tmpl.html';
                    break;
                case 2:
                    value = scope.filter.stringValue;
                    if (value) {
                        scope.filter.stringValue = new Date(value);
                    }
                    result = 'shared/list/templates/serverside/datefilter.tmpl.html';
                    break;
                case 3:
                    scope.localizationMap = TranslationService.getDatePickerTranslations();
                    scope.firstDayOfWeek = $mdDateLocale.firstDayOfWeek;

                    var less30Date = impactX.getDateInPast(30);

                    var less90Date = impactX.getDateInPast(90);

                    var lastDate = impactX.getDateInPast(0);

                    scope.customTemplates = [
                        {
                            name: scope.localizationMap.last30Days,
                            dateStart: less30Date,
                            dateEnd: lastDate
                        },
                        {
                            name: scope.localizationMap.last90Days,
                            dateStart: less90Date,
                            dateEnd: lastDate
                        }
                    ];
                    if (!scope.filter.datePickerModel) {
                        scope.filter.datePickerModel = {};
                    }
                    else {
                        if (scope.filter.datePickerModel.dateStart) {
                            scope.filter.datePickerModel.dateStart = new Date(scope.filter.datePickerModel.dateStart);
                        }
                        if (scope.filter.datePickerModel.dateEnd) {
                            scope.filter.datePickerModel.dateEnd = new Date(scope.filter.datePickerModel.dateEnd);
                        }
                        if (scope.filter.datePickerModel.dateStart && scope.filter.datePickerModel.dateEnd)
                        {
                            if (scope.filter.datePickerModel.selectedTemplate === "false") {
                                scope.filter.datePickerModel.selectedTemplate = "";
                            }
                            scope.filter.datePickerModel.selectedTemplateName = impactX.formatDateFilterTemplate(scope.filter.datePickerModel, $filter);
                        }
                    }
                    result = 'shared/list/templates/serverside/daterangefilter.tmpl.html';
                    scope.$watchCollection(
                        function() {
                            return scope.filter.datePickerModel;
                            },
                        function(oldVal, newVal) {
                            if(scope.filter.datePickerModel.dateStart) {
                                if (newVal.selectedTemplate != oldVal.selectedTemplate ||
                                    (newVal.selectedTemplate == false && (oldVal.dateStart != newVal.dateStart || oldVal.dateEnd != newVal.dateEnd))) {
                                    scope.ctrl.refreshData();
                                }

                            }
                        });
                    break;
                case 4:
                    result = 'shared/list/templates/serverside/popupfilter.tmpl.html';
                    break;

                case 5:
                    result = 'shared/list/templates/serverside/checkboxgroup.tmpl.html';
                    break;
                case 6:
                    result = 'shared/list/templates/serverside/autocompletefilter.tmpl.html';
                    break;
                case 7:
                    result = 'shared/list/templates/serverside/autocompletestringfilter.tmpl.html';
                    break;
                case 8:
                    result = 'shared/list/templates/serverside/autocompletewithcheckboxfilter.tmpl.html';
                    break;
                case 10:
                    result = '';
                    break;
                default:
                    break;
            }
            scope.template = result;

        },
        transclude: true
    };
}]);